module.exports = __webpack_public_path__ + "static/media/yukon.fdd2e94c.png";